import { render, staticRenderFns } from "./effectScatter.vue?vue&type=template&id=3899700c&"
import script from "./effectScatter.vue?vue&type=script&lang=js&"
export * from "./effectScatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports